import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import Navigation from './Navigation';
import LandingPage from './Landing';
import SignUpPage from './SignUp';
import SignInPage from './SignIn';
import PasswordForgetPage from './PasswordForget';
import HomePage from './Home';
import AccountPage from './Account';
import VerifyEmailPage from './VerifyEmail';

import * as routes from '../constants/routes';


import Reboot from 'material-ui/Reboot';

import withAuthentication from './withAuthentication';


const App = () =>

      <Router>
        <div>
          <Reboot /> { /* Material UI Next boilerplate (0 margin) */ }

          <Navigation />

          <Route exact path={routes.LANDING} component={() => <LandingPage />} />
          <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
          <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
          <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
          <Route exact path={routes.VERIFY_EMAIL} component={() => <VerifyEmailPage />} />
          <Route exact path={routes.HOME} component={() => <HomePage />} />
          <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
        </div>
      </Router>


export default withAuthentication(App);


// WEBPACK FOOTER //
// ./src/components/App.js